export default {
	pending: 0,
	confirmed: 1,
	approved: 2,
	cancelled: 3
}